import React, { useEffect } from "react";
import { Card, Grid, GridColumn, Separator, BoldSpan } from "@atlassiansox/microscopekit";
import SectionMessage from "@atlaskit/section-message";
import { useSteadyStates } from "../useSteadyStates";
import { SteadyStateEditor } from "../SteadyStateEditor";
import { SteadyStatesList } from "../SteadyStatesList";
export var SteadyStatesManager = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = useSteadyStates(value), steadyStates = _b.steadyStates, steadyStateBeingEdited = _b.steadyStateBeingEdited, saveSteadyState = _b.saveSteadyState, cancelSteadyState = _b.cancelSteadyState, editSteadyState = _b.editSteadyState, deleteSteadyState = _b.deleteSteadyState;
    useEffect(function () {
        onChange(steadyStates);
    }, [steadyStates, onChange]);
    return (React.createElement(Card, null,
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 12 },
                React.createElement(SectionMessage, { appearance: "info" },
                    "Refer",
                    " ",
                    React.createElement("a", { href: "http://go/brahmos-stop-conditions", target: "_blank", rel: "noopener noreferrer" }, "http://go/brahmos-stop-conditions"),
                    " ",
                    "for more details"))),
        React.createElement(Separator, null),
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 6 },
                React.createElement("h4", null,
                    "Stop Conditions",
                    React.createElement(BoldSpan, null, "[Optional]")),
                React.createElement(SteadyStateEditor, { value: steadyStateBeingEdited, onSave: saveSteadyState, onCancel: cancelSteadyState })),
            React.createElement(GridColumn, { medium: 6 },
                React.createElement("h3", null, "Stop Condition Preview"),
                React.createElement(Separator, null),
                React.createElement(SteadyStatesList, { steadyStates: steadyStates, onEdit: editSteadyState, onDelete: deleteSteadyState })))));
};
